// export const API_BASE_URL = 'http://localhost:8000';
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_ROUTE ||
  "https://2vt8egydxd.execute-api.eu-west-3.amazonaws.com/prod";
// process.env.REACT_APP_API_BASE_ROUTE || "http://127.0.0.1:8000";

//
// type BaseResponseType = {
//   status: string;
//   message: string;
// };
